import { getMeta } from '../meta.js';
import { showMessageBox } from '../msgbox.jsx';
import { insertTags } from '../parsing.js';
import UploadClient from '../ext/eeprom.js';

export function initForumUploads(form, textElem, parserElem, oninserted) {
    const storagePool = getMeta('forum-storage-pool');
    if(!storagePool) return;

    const eepromClient = new UploadClient(storagePool);
    const eepromHistory = <div class="eeprom-widget-history-items"/>;
    const eepromHandleFileUpload = async file => {
        const uploadElemNameValue = <div class="eeprom-widget-file-name-value" title={file.name}>{file.name}</div>;
        const uploadElemName = <a class="eeprom-widget-file-name" target="_blank">{uploadElemNameValue}</a>;
        const uploadElemProgressText = <div class="eeprom-widget-file-progress">Please wait...</div>;
        const uploadElemProgressBarValue = <div class="eeprom-widget-file-bar-fill" style={{ width: '0%' }}/>;
        const uploadElem = <div class="eeprom-widget-file">
            <div class="eeprom-widget-file-info">
                {uploadElemName}
                {uploadElemProgressText}
            </div>
            <div class="eeprom-widget-file-bar">
                {uploadElemProgressBarValue}
            </div>
        </div>;

        eepromHistory.insertAdjacentElement('afterbegin', uploadElem);

        const explodeUploadElem = () => { uploadElem.remove(); };
        const uploadTask = eepromClient.createUpload(file);

        uploadTask.onProgress(prog => {
            uploadElemProgressBarValue.style.width = `${Math.ceil(prog.progress * 100)}%`;
            uploadElemProgressText.textContent = `${prog.progress.toLocaleString(undefined, { style: 'percent' })} (${prog.total - prog.loaded} bytes remaining)`;
        });

        try {
            const fileInfo = await uploadTask.start();

            uploadElem.classList.add('eeprom-widget-file-done');
            uploadElem.appendChild(<input type="hidden" name="attachment" value={fileInfo.id} />);
            uploadElemName.href = fileInfo.url;
            uploadElemProgressText.textContent = '';

            const insertTheLinkIntoTheBoxEx2 = () => {
                let insertText = location.protocol + fileInfo.url;

                if(parserElem.value == 'bb') { // bbcode
                    if(fileInfo.isImage())
                        insertText = `[img]${fileInfo.url}[/img]`;
                    else if(fileInfo.isAudio())
                        insertText = `[audio]${fileInfo.url}[/audio]`;
                    else if(fileInfo.isVideo())
                        insertText = `[video]${fileInfo.url}[/video]`;
                } else if(parserElem.value == 'md') { // markdown
                    if(fileInfo.isMedia())
                        insertText = `![](${fileInfo.url})`;
                }

                insertTags(textElem, insertText, '');
                textElem.value = textElem.value.trim();
                if(oninserted) oninserted();
            };

            uploadElemProgressText.appendChild(<a href="javascript:void(0)" onclick={() => insertTheLinkIntoTheBoxEx2()}>Insert</a>);
            uploadElemProgressText.appendChild(document.createTextNode(' '));
            uploadElemProgressText.appendChild(<a href="javascript:void(0)" onclick={() => {
                eepromClient.deleteUpload(fileInfo)
                    .then(() => explodeUploadElem())
                    .catch(ex => {
                        console.error(ex);
                        showMessageBox(ex, 'Upload Error');
                    });
            }}>Delete</a>);

            insertTheLinkIntoTheBoxEx2();
        } catch(ex) {
            let errorText = 'Upload aborted.';

            if(!ex.aborted) {
                console.error(ex);
                errorText = ex.toString();
            }

            uploadElem.classList.add('eeprom-widget-file-fail');
            uploadElemProgressText.textContent = errorText;
            await showMessageBox(errorText, 'Upload Error');
        }
    };

    const eepromFormInput = <input type="file" multiple={true} class="eeprom-widget-form-input" onchange={() => {
        const files = eepromFormInput.files;
        for(const file of files)
            eepromHandleFileUpload(file);
        eepromFormInput.value = '';
    }}/>;

    const eepromForm = <label class="eeprom-widget-form">
        {eepromFormInput}
        <div class="eeprom-widget-form-text">Select Files...</div>
    </label>;

    const eepromWidget = <div class="eeprom-widget">
        {eepromForm}
        <div class="eeprom-widget-history">{eepromHistory}</div>
    </div>;

    form.appendChild(eepromWidget);

    textElem.addEventListener('paste', ev => {
        if(ev.clipboardData && ev.clipboardData.files.length > 0) {
            ev.preventDefault();

            const files = ev.clipboardData.files;
            for(const file of files)
                eepromHandleFileUpload(file);
        }
    });

    const stubHandler = ev => {
        ev.preventDefault();
        ev.stopPropagation();
    };

    const dropHandler = ev => {
        ev.preventDefault();
        ev.stopPropagation();

        if(ev.dataTransfer && ev.dataTransfer.files.length > 0) {
            const files = ev.dataTransfer.files;
            for(const file of files)
                eepromHandleFileUpload(file);
        }
    };

    document.body.addEventListener('dragenter', stubHandler);
    document.body.addEventListener('dragover', stubHandler);
    document.body.addEventListener('dragleave', stubHandler);
    document.body.addEventListener('drop', dropHandler);

    return () => {
        document.body.removeEventListener('dragenter', stubHandler);
        document.body.removeEventListener('dragover', stubHandler);
        document.body.removeEventListener('dragleave', stubHandler);
        document.body.removeEventListener('drop', dropHandler);
    };
}
